<form class="filter" #formElement [formGroup]="form">

    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="number" placeholder="Nùmero">
        <mat-error *ngIf="f.number.errors && f.number.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <mat-select formControlName="medicalFeePeriod" placeholder="Período">
            <mat-option *ngFor="let medicalFeePeriodFilter of medicalFeePeriodFilters" [value]="medicalFeePeriodFilter">
                {{ medicalFeePeriodFilter.Name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="f.medicalFeePeriod.errors && f.medicalFeePeriod.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha desde">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="f.from.errors && f.from.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha hasta">
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error *ngIf="f.to.errors && f.to.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>


    <mat-form-field class="full-width">
        <input type="text" #client matInput placeholder="Médico" formControlName="physician" [matAutocomplete]="autPhysician">
        <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysician.displayFn">
            <mat-option *ngFor="let physician of filteredPhysicianOptions | async" [value]="physician">
                {{ physician.Name }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="f.physician.errors && f.physician.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="paymentDate" [matDatepicker]="pickerPaymentDate" placeholder="Fecha liquidación">
        <mat-datepicker-toggle matSuffix [for]="pickerPaymentDate"></mat-datepicker-toggle>
        <mat-datepicker #pickerPaymentDate></mat-datepicker>
        <mat-error *ngIf="f.paymentDate.errors && f.paymentDate.errors.formEmpty">
            Debe ingresar al menos un filtro
        </mat-error>
    </mat-form-field>
</form>